<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>赛季管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card>
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        label-width="80px"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="赛事活动" prop="activityType">
              <el-select
                disabled
                placeholder="请选择"
                style="width: 100%"
                v-model="activityType"
                @change="getList"
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span class="title_class">赛季列表</span>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-button type="primary" plain @click="handlaTo">字典赛季管理</el-button>
          <el-button type="primary" @click="showAdd">添加赛季</el-button>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="list"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛事活动" prop="activityName"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="状态" prop="isIng">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isIng === 1" type="success" size="mini">当前赛季</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-setting"
              size="mini"
              :disabled="scope.row.isIng === 1"
              @click="setSeason(scope.row)"
            >设置为当前赛季</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top: 15px;">
        <el-col :span="24">
          <div class="desc">切换赛季注意事项：</div>
          <div class="desc">1、强制小程序所有人下线，重新获取赛季</div>
          <div class="desc">2、所有产品更新为当前赛季</div>
          <div class="desc">3、更改赛程关联赛季</div>
          <div class="desc">4、切换赛季可能导致部分词库失效，请谨慎操作</div>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog title="添加赛季" width="480px" :visible.sync="dialogVisible">
      <div v-if="isSystem" class="add-row">系统检测到新增赛季{{ season }}，是否添加？</div>
      <div class="add-row">
        <span class="addLabel">赛事活动</span>
        <el-select
          disabled
          placeholder="请选择"
          style="width: 300px; margin-left: 12px;"
          v-model="addActivityType"
        >
          <el-option
            v-for="item in activityTypeList"
            :key="item.dictCode"
            :label="item.dictLabel"
            :value="item.dictValue"
          ></el-option>
        </el-select>
      </div>
      <div class="add-row" v-if="!isSystem">
        <span class="addLabel">赛季</span>
        <el-select
          placeholder="请选择"
          style="width: 300px; margin-left: 12px;"
          v-model="season"
        >
          <el-option
            v-for="item in seasonList"
            :key="item.dictCode"
            :label="item.dictLabel"
            :value="item.dictValue"
          ></el-option>
        </el-select>
      </div>
      <div class="footer">
        <el-button @click="handleToClose">取消</el-button>
        <el-button type="primary" @click="addSeason">确认添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'season',
  data () {
    return {
      activityType: String(this.$chnEngStatusCode.activityType),
      activityTypeList: this.$userInfo.getDataList(this, 'activity_type').then(value => { this.activityTypeList = value }),
      list: [],
      seasonList: [],
      dialogVisible: false,
      season: '',
      isSystem: false,
      addActivityType: String(this.$chnEngStatusCode.activityType)
    }
  },
  created () {
    this.getList()
    if (this.$route.query.season) {
      this.isSystem = true
      this.season = this.$route.query.season
      this.dialogVisible = true
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 字典表-赛季
    getDictList () {
      this.$userInfo.getDataList(this, 't_season').then(list => {
        this.seasonList = list
      })
    },
    getList () {
      this.$http.get(`season/getSeasonActivityList/${this.activityType}`).then(res => {
        if (res.code === 200) {
          this.list = res.data
        }
      })
    },
    setSeason ({ activityType, season }) {
      this.$http.post('/season/switchingSeason', { activityType, season }).then(res => {
        if (res.code === 200) {
          // 成功回调
          if (activityType === 1) { // 个人赛设置默认赛季
            this.getDefaultSeason(activityType)
          } else {
            this.getList()
          }
        }
      })
    },
    getDefaultSeason (activityType) {
      this.$http.get(`/season/seasonActivityIng/${activityType}`).then(res => {
        if (res.code === 200) {
          const season = res.data.season
          localStorage.setItem('SEASON_1', season)
          this.$chnEngStatusCode.defaultSeason = season
          this.getList()
        }
      })
    },
    handlaTo () {
      this.$router.push('/system/dict/data?t=t_season')
    },
    addSeason () {
      this.$http.post('season/saveSeasonByActivityType', {
        activityName: this.activityTypeList.find(item => item.dictValue === this.addActivityType).dictLabel,
        activityType: Number(this.addActivityType), // 个人赛
        season: this.season
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('添加成功')
          this.dialogVisible = false
          this.getList()
          if (this.$route.query.season) {
            this.clearQuery()
          }
        }
      }).catch(() => {
        this.handleToClose()
      })
    },
    clearQuery () {
      this.$router.replace({
        path: '/system/season'
      })
    },
    handleToClose () {
      this.season = ''
      this.isSystem = false
      this.dialogVisible = false
      this.clearQuery()
    },
    showAdd () {
      this.dialogVisible = true
      this.getDictList()
    }
  }
}
</script>
<style lang="less" scoped>
.desc{
  font-size: 12px;
  color: #888;
}
.refresh{
  color: #409EFF;
  margin-left: 12px;
  cursor: pointer;
}
.footer{
  margin-top: 42px;
  text-align: center;
}
.addLabel{
  display: inline-block;
  width: 78px;
}
.add-row{
  margin-bottom: 20px;
}
</style>
